
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import genericModulePlanService from '@/apps/shared/services/getGenericModulePlan-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default defineComponent({
        components: {
            XBreadcrumb,
            WhatsApp
        },
        data() {
            return {
                data: [],
                selectedValue: null,
                QuotationJson: null,
                selectedPlan: null,
                col: 2,
                plansLength: null,
                covers: [],
                dataPlanQuotationComplete: [],
                breadcrumItems: [
                    { text: 'Inicio', path: '/hogar-premium' },
                    { text: 'Cotizá tu hogar', path: '/hogar-premium/cotizar' },
                    { text: 'Elegi Plan', path: '/hogar-premium/elegiPlan' },
                ],
                objectPlanCompleteWithCoverCapital: [],
                body: null,
                capitalPlan: 0,
                genericModulePlansWithoutPlan5: [],
                genericModulePlansComplete: [],
                tabTwoData: null,
                buildingCapitalSelected: null,
                securitySystem: null,
                tabOneWelcome: null,
                tabFourData: null,
                referente: null
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Hogar Premium';
                const actualPath = '/hogar-premium';
                const actualStep = 'quoted';

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = this.tabOneWelcome.lastName;
                request.firstName = this.tabOneWelcome.firstName;
                request.phone = this.tabOneWelcome.areaCode + this.tabOneWelcome.telephone;
                request.mail = this.tabOneWelcome.email;
                request.quotePlan = this.objectPlanCompleteWithCoverCapital.map(plan => plan.planDescription).join(' - ');

                const securitySystemString = Array.isArray(this.securitySystem) && this.securitySystem.length > 0
                    ? this.securitySystem.join(', ')
                    : "No";

                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Localidad: " + this.tabTwoData.selectedLocality.text
                    + " - Tipo: " + this.tabTwoData.articleCode.description.trim()
                    + " - M2: " + Number(this.tabTwoData.surfaceHouse).toLocaleString('es-AR')
                    + " - Valor: $" + Number(this.buildingCapitalSelected.code).toLocaleString('es-AR')
                    + " - Medidas Seguridad: " + securitySystemString;

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultFamilyCombinedGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            selectedPlans: function (quotationData) {
                var pricingId = quotationData.pricingId;
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': this.tabOneWelcome.email,
                            'product': 'hogarPremium',
                            'event': 'cotizador-hogar-premium-plan',
                            'plan': quotationData.planDescription,
                            'referente': this.referente
                        });
                        this.$router.push({ name: 'FamilyHogarPremiumClientData' });
                    }
                    else {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': this.tabOneWelcome.email,
                            'product': 'hogarPremium',
                            'event': 'errorServidor',
                            'paso': 'cotizador-hogar-premium-plan',
                            'referente': this.referente
                        });
                    }
                });
            },
            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'tabFourFamilyCombinedPremium',
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },

            dataAmparos: function () {
                var DataQuotation = sessionStorage.getItem("DataQuotation");
                this.QuotationJson = JSON.parse(DataQuotation!);

                var planComplete = this.QuotationJson.dataPlanQuotationComplete[3].finallyCalculationResults;
                var coverNotInclude = new Set([44, 45, 50, 51]);
                this.QuotationJson.dataPlanQuotationComplete.forEach(d => {
                    if (d.module == "1") {
                        var planWithModule1 = this.QuotationJson.dataPlanQuotationComplete.filter(o => o.module == d.module)
                        if (planWithModule1.length > 1) {
                            if (planWithModule1[0].premioMensual > planWithModule1[1].premioMensual) {
                                d.module = 2;
                                d.planDescription = "Plan 2";
                                d.planCode = 2;
                            }
                        }
                    }
                    else {
                        d.module = (parseInt(d.module) + 1).toString();
                        d.planDescription = "Plan " + d.module;
                        d.planCode = parseInt(d.planCode) + 1;
                    }
                    var plan = [];
                    d.covers.filter(o => !coverNotInclude.has(o.coverNumber)).forEach(c => {
                        var fcr = d.finallyCalculationResults.find(o => o.detalleInt == (c.coverNumber == 6 ? 1 : (c.coverNumber == 7 ? 2 : c.coverNumber)))
                        this.capitalPlan = 0;
                        if (fcr != null) {
                            this.capitalPlan = fcr.capital;
                        }
                        else {
                            if (planComplete.find(o => o.descripcion == c.description) != null) {
                                this.capitalPlan = planComplete.find(o => o.descripcion == c.description).capital
                            }
                        }
                        this.body =
                        {
                            capital: this.capitalPlan,
                            capitalFormatted: "$" + this.capitalPlan.toLocaleString(),
                            coverDescription: c.description,
                            coverNumber: c.coverNumber,
                            value: c.value,
                            tooltip: c.tooltip,
                            commercialDescriptId: c.commercialDescriptId,
                            planCode: d.planCode,
                            pricingId: d.pricingId
                        };
                        plan.push(this.body);
                    })
                    this.objectPlanCompleteWithCoverCapital.push(
                        {
                            pricingId: d.pricingId,
                            planCode: d.planCode,
                            planDescription: d.planDescription,
                            module: d.module,
                            plans: plan,
                            premioMensual: d.premioMensual,
                            premioMensualFormatted: d.premioMensualFormatted,
                            premioMensualSinDescuentoFormatted: d.premioMensualSinDescuentoFormatted,
                            planSelectionNotes: "",
                            suggestedPlan: ""

                        });

                })
                if (DataQuotation != null) {
                    this.dataPlanQuotationComplete = this.QuotationJson.dataPlanQuotationComplete.sort((a, b) => a.planCode - b.planCode);
                    this.objectPlanCompleteWithCoverCapital = this.objectPlanCompleteWithCoverCapital.sort((a, b) => a.planCode - b.planCode).filter(o => o.planCode != 5);
                    this.plansLength = this.objectPlanCompleteWithCoverCapital.length;
                    sessionStorage.setItem('dataPlanWithCoversCapital', JSON.stringify(this.objectPlanCompleteWithCoverCapital));
                    this.rate = this.QuotationJson.discountRate;
                }
                NF.UI.Page.unblock();
            },

            GetGenericModulePlan: function () {
                var productId = 927;
                genericModulePlanService.getGenericModulePlans(productId).then(response => {
                    this.genericModulePlansComplete = response;
                    this.genericModulePlansComplete = this.genericModulePlansComplete.filter(o => o.planCode != 5)
                    this.genericModulePlansWithoutPlan5 = response;
                    this.genericModulePlansWithoutPlan5 = this.genericModulePlansWithoutPlan5.filter(o => o.planCode != 2)

                    var a = (JSON.parse(sessionStorage.getItem("dataPlanWithCoversCapital")))
                    for (var i = 0; i < a.length; i++) {
                        this.objectPlanCompleteWithCoverCapital[i].planSelectionNotes = this.genericModulePlansComplete[i].planSelectionNotes;
                        this.objectPlanCompleteWithCoverCapital[i].suggestedPlan = this.genericModulePlansComplete[i].suggestedPlan;
                    }
                    sessionStorage.setItem('dataPlanWithCoversCapital', JSON.stringify(this.objectPlanCompleteWithCoverCapital));
                });
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                this.tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                this.tabFourData = JSON.parse(sessionStorage.getItem("TabFourData"));
                this.tabTwoData = JSON.parse(sessionStorage.getItem("TabTwoData"));
                this.buildingCapitalSelected = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                this.securitySystem = JSON.parse(sessionStorage.getItem("SecuritySystem"));
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                const additionalInformation = {
                    'Tipo de vivienda': this.tabTwoData.articleCode.description,
                    'Metros': this.tabTwoData.surfaceHouse,
                    'Suma asegurada elegida': this.buildingCapitalSelected.code.toString(),
                    'Sistema de detección de incendios': (this.tabFourData == null) ? 'false' : this.tabFourData["Discount20"].toString(),
                    'Personal de vigilancia': (this.tabFourData == null) ? 'false' : this.tabFourData["Discount21"].toString(),
                    'Puertas blindadas': (this.tabFourData == null) ? 'false' : this.tabFourData["Discount22"].toString(),
                    'Alarma contra robo monitoreada': (this.tabFourData == null) ? 'false' : this.tabFourData["Discount23"].toString(),
                    'Localidad': this.tabTwoData.selectedLocality.name,
                };
                CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.tabOneWelcome.email, location.href, this.tabOneWelcome.areaCode, this.tabOneWelcome.telephone, 927, false, "5", additionalInformation, this.tabOneWelcome.lastName, this.tabOneWelcome.name);
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                sessionStorage.removeItem("pressBack");
                var fromTabPassFour = sessionStorage.getItem("FromTabPassFour");
                var fromTabFive = sessionStorage.getItem("FromTabFive");
                NF.UI.Page.block();
                this.dataAmparos();
                this.GetGenericModulePlan();

                if (fromTabPassFour == "true" && fromTabFive == "true") {
                    sessionStorage.setItem("FromTabPassFour", "false");
                } else {
                    if (fromTabPassFour == "false" && fromTabFive == "true") {
                        sessionStorage.setItem("FromTabFive", "false");
                        sessionStorage.setItem("FromTabPassFour", "true");
                    } else {
                        sessionStorage.setItem("FromTabPassFour", "false");
                        sessionStorage.setItem("FromTabFive", "true");
                    }
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

                const parallelPromises = [
                    this.getInitData(),
                    this.updateByProductGoogleAnalytics()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.pageCustomization();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
